import React from 'react'
import { defaultValues, calculateDeterminationSubmitValues } from '../../../../../accs-gov-enrolments/helpers'
import DefaultForm from '../../../../../ui/forms/default-form'
import ACCSForm from '../../../../accs/form'
import { available } from '../../view/helper'

const formValue = 'create_determination'

const actionForm = ({ child, regHolderId }) => ({ handleSuccess }) => {
  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/children/${child.crn}/accs/submit-determination`
      }
      name={formValue}
      label='Create Determination'
      loadingTitle='Submitting ACCS Determination...'
      calculateSubmitValues={calculateDeterminationSubmitValues}
      handleSuccess={() =>
        handleSuccess(
          { [formValue]: 'ACCS Determination has been created.' },
          formValue
        )
      }
      formOptions={{ defaultValues: defaultValues(child) }}
      formComponent={(props) => <ACCSForm {...props} isDetermination={true} child={child} />}
    />
  )
}

export const createDetermination = ({ child, available_actions, regHolderId, refresh_accs_gov_enrolments }) => {
  return available({ available_actions })
    ? {
      label: 'New Determination',
      value: 'create_determination',
      actionForm: actionForm({ child, regHolderId }),
      onCompletePreserveAction: true,
      onComplete: () => refresh_accs_gov_enrolments(child.accs_path)
    }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/create-determination/index.js